//module
import Vue from 'vue'
import VueRouter from "vue-router";
//component
import App from './App.vue'
import Page from './container/Page.vue'
import Content from './container/Content.vue'

Vue.use(VueRouter);

Vue.config.productionTip = false

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Page,
            children: [
                { path: "", component: Content, props: { "nid": 1 } },
                { path: "contact", component: Content, props: { "nid": 3 } },
                { path: "realisation", component: Content, props: { "nid": 4 } },
                { path: "realisation/4", redirect: "realisation" },
                { path: "realisation/:nid", component: Content, props: { "nid": 0 } },
                { path: "404", component: Content, props: { "nid": 0 } },
            ]
        },
        { path: "*", redirect: "/404" },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')